import React from 'react';

const TypingIndicator = () => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.8rem 0.8rem',
      backgroundColor: '#ffffff',
      borderRadius: '18px 18px 18px 18px',
      maxWidth: 'fit-content',
      margin: '0.5rem 0'
    }}>
      <img 
        src="pb.gif" 
        alt="Pool Brain" 
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
      <div style={{ display: 'flex', gap: '0.25rem', alignItems: 'center' }}>
        {[0, 1, 2].map((i) => (
          <div key={i} style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#4F7CFF',
            animation: 'bounce 1.4s infinite ease-in-out both',
            animationDelay: i === 0 ? '-0.32s' : i === 1 ? '-0.16s' : '0s'
          }}></div>
        ))}
      </div>
      <style>
        {`
          @keyframes bounce {
            0%, 80%, 100% { transform: scale(0); }
            40% { transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
};

export default TypingIndicator;